import { Outlet, Link } from "react-router-dom";
import ResponsiveAppBar from "../components/ResponsiveAppBar";
import ResponsiveFooter from "../components/ResponsiveFooter";
import { GrowingBackground, InventoryBackground, MainBackground, PatchingBackground, WarehousingBackground, LogisticsBackground, InvoicingBackground } from "../assets/images/backgrounds";
import { useAppSelector } from "../hooks";
import { useEffect, useState } from "react";
import { Grid } from "@mui/material";



const Layout = () => {
  const backgroundSelector = useAppSelector((state) => {return state.application.backgroundPath} )
  const [background, setBackground] = useState(MainBackground);

  useEffect(() => {
    console.log("IN LAYOUT USE EFFECT", backgroundSelector);
    if (backgroundSelector?.includes('growingbg')) {
      setBackground(GrowingBackground);
      return;
    }

    if (backgroundSelector?.includes('inventorybg')) {
      setBackground(InventoryBackground);
      return;
    }

    if (backgroundSelector?.includes('loginbg')) {
      setBackground(MainBackground);
      return;
    }

    if (backgroundSelector?.includes('patchingbg')) {
      setBackground(PatchingBackground);
      return;
    }

    if (backgroundSelector?.includes('spaceallocationbg')) {
      setBackground(WarehousingBackground);
      return;
    }

    if (backgroundSelector?.includes('spaceallocationbg')) {
      setBackground(WarehousingBackground);
      return;
    }

    if (backgroundSelector?.includes('logisticsbg')) {
      setBackground(LogisticsBackground);
      return;
    }

    if (backgroundSelector?.includes('invoicingbg')) {
      setBackground(InvoicingBackground);
      return;
    }

    setBackground(MainBackground);

  }, [backgroundSelector])
  return (
    <>
      <ResponsiveAppBar></ResponsiveAppBar>
       <div style={{backgroundImage: `url(${background})`, height:'100vh', backgroundSize:'100% 100%', backgroundRepeat:'no-repeat'}}>
        <Outlet />
      </div>
    </>
  )
};

export default Layout;